import React from "react";
import image1 from "../../assets/FooterBackground.png";
import { MdEmail, MdPhone, MdContentCopy } from "react-icons/md";
import { FaLinkedin, FaFacebook, FaInstagram } from "react-icons/fa";
import { MdMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";

const Footer = () => {
  const handleCopy = (text) => {
    navigator?.clipboard?.writeText(text);
  };
  return (
    <div
      className=" w-full bg-cover bg-center bg-no-repeat mt-10"
      style={{
        backgroundImage: `url(${image1})`,
        width: "100vw",
        maxWidth: "100%",
      }}
    >
      <div className="min-h-[400px]  flex flex-col items-center justify-center p-8 relative overflow-hidden">
        <div className="text-center z-10">
          <h2 className="text-white text-4xl font-bold mb-4 dmsans">
            " Get In Touch "
          </h2>
          <p className="text-gray-300 mb-8 max-w-md heebo">
            What's next? Feel free to reach out to me if you're looking for a
            developer, have a query, or simply want to connect.
          </p>

          <div className="space-y-2">
            <div className="flex items-center justify-center space-x-2 text-white mt-4">
              <MdMailOutline
                className="w-5 h-5 cursor-pointer hover:text-[#3FFFCC] transition-colors"
                onClick={() => handleCopy("infosaileshdani@gmail.com")}
              />
              <span className="text-xl text-[#3FFFCC] dmsans">
                infosaileshdani@gmail.com
              </span>
              <button
                onClick={() => handleCopy("infosaileshdani@gmail.com")}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <MdContentCopy className="w-4 h-4" />
              </button>
            </div>

            <div className="flex items-center justify-center space-x-2 text-white">
              <FiPhone
                className="w-5 h-5 cursor-pointer hover:text-[#3FFFCC] transition-colors"
                onClick={() => handleCopy("+91 8980 500 565")}
              />
              <span className="text-xl text-[#3FFFCC] dmsans">
                +91 8980 500 565
              </span>
              <button
                onClick={() => handleCopy("+91 8980 500 565")}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <MdContentCopy className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="mt-8">
            <p className="text-gray-400 mb-4 heebo">
              You may also find me on these platforms!
            </p>
            <div className="flex justify-center space-x-4">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <FaLinkedin className="w-6 h-6" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <FaFacebook className="w-6 h-6" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <FaInstagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
